export default __webpack_public_path__ + "static/media/outros.aa8bf20c.jpg";